export const isProduction = process.env.REACT_APP_BUILD_TYPE === "production";
export const isStaging = process.env.REACT_APP_BUILD_TYPE === "staging";

let baseUrl = "https://api.getset4education.co.uk/api/v1";
let domain = 'getset4education.co.uk';
if (!isProduction) {
  baseUrl = "https://getset4pe-getset4education-customer-v1.api.avamae.co.uk/api/v1";
  domain = ".avamae.co.uk";
} 

export const STOPLIGHT_BASE_URL =
  "https://stoplight.io/mocks/avamae/getset4pe-cloud-web-getset4education-customer-v1";
export const BASE_URL = baseUrl;
export const DOMAIN = domain;

export const endpoints = {
  auth: {
    login: `${BASE_URL}/publicrole/authmodule/login`,
    authLogin: `${BASE_URL}/publicrole/authmodule/autologin`,
    refreshAccessToken: `${BASE_URL}/publicrole/authmodule/refreshaccesstoken`,
    createPassword: `${BASE_URL}/publicrole/authmodule/createpassword`,
    user: `${BASE_URL}/userrole/clientsmodule/listclients`,
  },
  public: {
    navigation: {
      headerLinks: `${BASE_URL}/publicrole/navigationmodule/headerlinks`,
      footerLinks: `${BASE_URL}/publicrole/navigationmodule/footerlinks`,
    },
    subscription: {
      getSubscriptions: `${BASE_URL}/publicrole/subscriptionsmodule/getsubscriptions`,
      getSubscriptionsV2: `${BASE_URL}/publicrole/subscriptionsmodule/getsubscriptions_v2`,
      getSubscriptionsWithPromocode: `${BASE_URL}/publicrole/subscriptionsmodule/getsubscriptionswithpromocode`,
      getSubscriptionsWithPromocodeV2: `${BASE_URL}/publicrole/subscriptionsmodule/getsubscriptionswithpromocode_v2`,
      validateSchoolInfo: `${BASE_URL}/publicrole/subscriptionsmodule/validateschoolinfo`,
      createsSchoolUser: `${BASE_URL}/publicrole/subscriptionsmodule/createsschooluser`,
      createsSchoolUserFreeTrial: `${BASE_URL}/publicrole/subscriptionsmodule/createsschooluserfreetrial`,
      subscribeByInvoice: `${BASE_URL}/publicrole/subscriptionsmodule/subscribebyinvoice`,
      subscribeByCard: `${BASE_URL}/publicrole/subscriptionsmodule/subscribebycard`,
      updateAfter3DSecure: `${BASE_URL}/publicrole/subscriptionsmodule/updateafter3dsecure`,
      getSubscriptionsFreeTrial: `${BASE_URL}/publicrole/subscriptionsmodule/getsubscriptionsFreeTrial`,
      subscribeFreeTrial: `${BASE_URL}/publicrole/subscriptionsmodule/subscribefreetrial`,
      getPriceSummary: `${BASE_URL}/publicrole/subscriptionsmodule/getpricesummary`,
    },
  },
  forgottenPassword: {
    requestPasswordReset: `${BASE_URL}/publicrole/forgottenpasswordmodule/requestpasswordreset`,
    resetPassword: `${BASE_URL}/publicrole/forgottenpasswordmodule/resetpassword`,
  },
  dashboard: {
    list: `${BASE_URL}/schoolrole/dashboardmodule/dashboard`,
    availablePages: `${BASE_URL}/schoolrole/dashboardmodule/availablepages`,
    autoLoginToken: `${BASE_URL}/schoolrole/dashboardmodule/autologintoken`,
    restartTrial: `${BASE_URL}/schoolrole/dashboardmodule/restart-trial`,
  },
  subscriptions: {
    list: `${BASE_URL}/schoolrole/subscriptionsmodule/subscriptions`,
    upgradeSubscriptionsList: `${BASE_URL}/schoolrole/subscriptionsmodule/getupgradesubscriptions`,
    packages: `${BASE_URL}/schoolrole/subscriptionsmodule/addsubscriptions`,
    packagesV2: `${BASE_URL}/schoolrole/subscriptionsmodule/addsubscriptions_v2`,
    addsubscriptionswithpromocode: `${BASE_URL}/schoolrole/subscriptionsmodule/addsubscriptionswithpromocode`,
    addsubscriptionswithpromocodeV2: `${BASE_URL}/schoolrole/subscriptionsmodule/addsubscriptionswithpromocode_v2`,
    checkpromocode: `${BASE_URL}/schoolrole/subscriptionsmodule/checkpromocode`,
    subscribebyinvoice: `${BASE_URL}/schoolrole/subscriptionsmodule/subscribebyinvoice`,
    subscribeByCard: `${BASE_URL}/schoolrole/subscriptionsmodule/subscribebycard`,
    updatAfter3DSecure: `${BASE_URL}/schoolrole/subscriptionsmodule/updateafter3dsecure`,
    upgradeByCard: `${BASE_URL}/schoolrole/subscriptionsmodule/upgradebycard`,
    upgradeByInvoice: `${BASE_URL}/schoolrole/subscriptionsmodule/upgradebyinvoice`,
    updatAfter3DSecureUpgrade: `${BASE_URL}/schoolrole/subscriptionsmodule/updateafter3dsecureUpgrade`,
    getSchoolInfo: `${BASE_URL}/schoolrole/subscriptionsmodule/getschoolinfo`,
    updateSchoolInfo: `${BASE_URL}/schoolrole/subscriptionsmodule/updateschoolinfo`,
    getSchoolUsers: `${BASE_URL}/schoolrole/subscriptionsmodule/getschoolusers`,
    updateSchoolUserAccess: `${BASE_URL}/schoolrole/subscriptionsmodule/updateschooluseraccess`,
    getRenewalSubscriptions: `${BASE_URL}/schoolrole/subscriptionsmodule/getrenewalsubscriptions`,
    renewByInvoice: `${BASE_URL}/schoolrole/subscriptionsmodule/renewbyinvoice`,
    renewByCard: `${BASE_URL}/schoolrole/subscriptionsmodule/renewbycard`,
    updateAfter3DSecureRenew: `${BASE_URL}/schoolrole/subscriptionsmodule/updateafter3dsecureRenew`,
    getSubscriptionsFreeTrial: `${BASE_URL}/schoolrole/subscriptionsmodule/getsubscriptionsFreeTrial`,
    subscribeFreeTrial: `${BASE_URL}/schoolrole/subscriptionsmodule/subscribefreetrial`,
  },
  profile: {
    profileDetails: `${BASE_URL}/schoolrole/profilemodule/profile`,
    updateemailpreferences: `${BASE_URL}/schoolrole/profilemodule/updateemailpreferences`,
    updateprofile: `${BASE_URL}/schoolrole/profilemodule/updateprofile`,
  },
  manageUsers: {
    list: `${BASE_URL}/schoolrole/usermanagementmodule/list`,
    addUser: `${BASE_URL}/schoolrole/usermanagementmodule/adduser`,
    updateuser: `${BASE_URL}/schoolrole/usermanagementmodule/updateuser`,
    updateaccesspermissions: `${BASE_URL}/schoolrole/usermanagementmodule/updateaccesspermissions`,
    viewuser: `${BASE_URL}/schoolrole/usermanagementmodule/viewuser`,
    deleteuser: `${BASE_URL}/schoolrole/usermanagementmodule/deleteuser`,
    downloadUserTemplateCSV: `${BASE_URL}/schoolrole/usermanagementmodule/templatedownloadcsv`,
    downloadUserListCSV: `${BASE_URL}/schoolrole/usermanagementmodule/listdownloadcsv`,
    uploadUserListCSV: `${BASE_URL}/schoolrole/usermanagementmodule/uploadcsv`,
  },
  invoices: {
    list: `${BASE_URL}/schoolrole/invoicesmodule/list`,
    viewInvoice: `${BASE_URL}/schoolrole/invoicesmodule/viewinvoice`,
    downloadInvoice: `${BASE_URL}/schoolrole/invoicesmodule/downloadinvoice`,
  },
  manageschool: {
    getSchoolDetails: `${BASE_URL}/schoolrole/schoolmanagementmodule/school`,
    updateSchoolDetails: `${BASE_URL}/schoolrole/schoolmanagementmodule/updateschool`,
    updateArchivingDate: `${BASE_URL}/schoolrole/schoolmanagementmodule/updatearchivingdate`,
    archiveNow: `${BASE_URL}/schoolrole/schoolmanagementmodule/archivenow`,
  },
  subscribe: {
    subscriptionContent: `${STOPLIGHT_BASE_URL}/1302880/subscriptionsmodule/packages`,
  },
  wondeIntegration: {
    checkLinkStatus: `${BASE_URL}/schoolrole/wondeintegrationmodule/checkaccess`,
    getSchoolLinkList: `${BASE_URL}/schoolrole/wondeintegrationmodule/schools`,
    requestAccess: `${BASE_URL}/schoolrole/wondeintegrationmodule/requestaccess`,
    syncData: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncdata`,
    compareAcademicYears: `${BASE_URL}/schoolrole/wondeintegrationmodule/compareacademicyears`,
    syncMatchedData: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncmatcheddata`,
    classStep1List: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncclasses_namematch_list`,
    classStep1NameMatch: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncclasses_namematch`,
    classStep2ManualMatchList: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncclasses_manualmatch_list`,
    classStep2ManualMatch: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncclasses_manualmatch`,
    classStep3List: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncclasses_unmatchedwondeclasses_list`,
    classStep3UnmatchedWondeClasses: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncclasses_unmatchedwondeclasses`,
    classStep4List: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncclasses_unmatchedclasses_list`,
    classStep4UnmatchedClassesDelete: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncclasses_unmatchedclasses_delete`,
    pupilStep1List: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncpupils_namematch_list`,
    pupilStep1NameMatch: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncpupils_namematch`,
    pupilStep2ManualMatchList: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncpupils_manualmatch_list`,
    pupilStep2ManualMatch: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncpupils_manualmatch`,
    pupilStep3List: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncpupils_unmatchedwondepupils_list`,
    pupilStep3UnmatchedWondeClasses: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncpupils_unmatchedwondepupils`,
    pupilStep4List: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncpupils_unmatchedpupils_list`,
    pupilStep4UnmatchedClassesDelete: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncpupils_unmatchedpupils_delete`,
    prevMatchedRecordsClass: `${BASE_URL}/schoolrole/wondeintegrationmodule/matchedclasses`,
    prevMatchedRecordsPupil: `${BASE_URL}/schoolrole/wondeintegrationmodule/matchedpupil`,
  },
};
